/**
 * AddressTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Briefcase, Building2, Calendar, Clock, CreditCard, DollarSign, FileText, GraduationCap, Heart, Home, Mail, MapPin, Phone, Plus, RefreshCw, Trash2, User, Users, Wallet } from 'lucide-react';;

const AddressTab = ({ ctx }) => {
  const {
    formData,
    handleAddressChange,
  } = ctx;

  return (
          <TabsContent value="address">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-stone-700" />
                  Address Information (Infotype 0006)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Address Type</Label>
                    <select
                      value={formData.addresses[0]?.address_type}
                      onChange={(e) => handleAddressChange(0, 'address_type', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="CURRENT">Current Address</option>
                      <option value="PERMANENT">Permanent Address</option>
                      <option value="EMERGENCY">Emergency Address</option>
                    </select>
                  </div>
                  <div>
                    <Label>Country</Label>
                    <Input
                      value={formData.addresses[0]?.country}
                      onChange={(e) => handleAddressChange(0, 'country', e.target.value)}
                      placeholder="India"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label>Address Line 1 *</Label>
                    <Input
                      value={formData.addresses[0]?.address_line1}
                      onChange={(e) => handleAddressChange(0, 'address_line1', e.target.value)}
                      placeholder="123 Main Street"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label>Address Line 2</Label>
                    <Input
                      value={formData.addresses[0]?.address_line2}
                      onChange={(e) => handleAddressChange(0, 'address_line2', e.target.value)}
                      placeholder="Apt 4B"
                    />
                  </div>
                  <div>
                    <Label>City *</Label>
                    <Input
                      value={formData.addresses[0]?.city}
                      onChange={(e) => handleAddressChange(0, 'city', e.target.value)}
                      placeholder="Hyderabad"
                    />
                  </div>
                  <div>
                    <Label>State</Label>
                    <Input
                      value={formData.addresses[0]?.state}
                      onChange={(e) => handleAddressChange(0, 'state', e.target.value)}
                      placeholder="Telangana"
                    />
                  </div>
                  <div>
                    <Label>Postal Code *</Label>
                    <Input
                      value={formData.addresses[0]?.postal_code}
                      onChange={(e) => handleAddressChange(0, 'postal_code', e.target.value)}
                      placeholder="500001"
                    />
                  </div>
                  <div>
                    <Label>Phone</Label>
                    <Input
                      value={formData.addresses[0]?.phone}
                      onChange={(e) => handleAddressChange(0, 'phone', e.target.value)}
                      placeholder="+91-XXX-XXXXXXX"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default AddressTab;
